export default {
  materialPriceCalcSystem: Object.freeze({OSN: 'osn', USN: 'usn', OSN_LABEL: 'ОСН', USN_LABEL: 'УСН'}),
}
